import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult({ mode }) {
  const location = useLocation();
  const [state, setState] = useState(mode === "cancel" ? "cancel" : "checking");
  const [type, setType] = useState("promotion");

  useEffect(() => {
    if (mode === "cancel") return;
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.type) setType(data.type);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      if (tries < 10) setTimeout(poll, 2000); else setState("error");
    };
    poll();
  }, [mode, location.search]);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-5 py-24 text-center" data-testid="payment-result">
      {state === "checking" && (<><Loader2 className="animate-spin text-[#002FA7]" size={40} /><h1 className="mt-4 font-display text-2xl font-extrabold">Confirming your payment…</h1></>)}
      {state === "paid" && type === "business_plan" && (<><CheckCircle2 className="text-[#155724]" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold" data-testid="payment-success">Welcome to Business Pro! 👑</h1><p className="mt-2 text-gray-500">Unlimited CSV imports are unlocked and all your listings are now promoted to the top of search.</p><Link to="/dashboard" data-testid="go-dashboard" className="mt-6 rounded-full bg-[#002FA7] px-6 py-3 font-bold text-white">Go to dashboard</Link></>)}
      {state === "paid" && type !== "business_plan" && (<><CheckCircle2 className="text-[#155724]" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold" data-testid="payment-success">Your listing is now promoted! 🚀</h1><p className="mt-2 text-gray-500">It will appear at the top of search results in its region for the days you selected.</p></>)}
      {state === "cancel" && (<><XCircle className="text-gray-400" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold">Payment cancelled</h1></>)}
      {state === "error" && (<><XCircle className="text-[#FF3B30]" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold">We couldn't confirm the payment</h1></>)}
      <Link to="/" className="mt-6 rounded-full bg-[#002FA7] px-6 py-3 font-bold text-white">Back to marketplace</Link>
    </div>
  );
}
